import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { defaultProfileSettings, ProfileSettings } from '../../../../core/models';

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss'],
  standalone: false
})
export class ProfileSettingsComponent implements OnInit, OnChanges {

  @Input() settings: ProfileSettings | undefined;
  @Input() nemKontoEnabled = false;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  value: ProfileSettings = {
    ...defaultProfileSettings
  };
  form: FormGroup = new FormGroup({
    logins: new FormArray([]),
    signups: new FormArray([]),
    force: new FormControl<boolean>(this.value.force),
    confirmation: new FormControl<boolean>(this.value.confirmation),
    allow_copy_of_rejection: new FormControl<boolean>(this.value.allow_copy_of_rejection),
    allow_copy_of_approved: new FormControl<boolean>(this.value.allow_copy_of_approved),
    account_alert_on_payment_request: new FormControl<boolean>(this.value.account_alert_on_payment_request),
    allow_share_applications: new FormControl<boolean>(this.value.allow_share_applications),
    underage: new FormControl<number>(this.value.underage, [Validators.required, Validators.min(15), Validators.max(25)]),
    prefer_applicant_nem_konto: new FormControl<boolean>(this.value.prefer_applicant_nem_konto),
    payment_request_notice_days: new FormControl<number>(this.value.payment_request_notice_days, [Validators.required, Validators.min(2)]),
  });

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      const disabled = this.form.disabled;
      this.settings = changes['settings'].currentValue;
      if (this.settings) {
        this.value = { ...defaultProfileSettings, ...this.settings };
      }
      this.setFormValue();
      if (disabled) {
        this.form.disable();
      }
    }
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = { ...defaultProfileSettings, ...this.settings };
    this.setFormValue();
    this.form.disable();
  }

  doSave(): void {
    this.saveSettings.emit(this.form);
    this.form.disable();
  }

  get isLoginSameAsSignUp(): boolean {
    return this.signups.value.sort().toString() === this.logins.value.sort().toString();
  }

  hasLoginType(value: string): boolean {
    return this.logins.value.includes(value);
  }

  hasSignupType(value: string): boolean {
    return this.signups.value.includes(value);
  }

  onLoginTypeToggle(type: string, checked: boolean) {
    if (checked) {
      this.logins.push(new FormControl(type));
    } else {
      const index = this.logins.controls.findIndex((control) => control.value === type);
      this.logins.removeAt(index)
    }
  }

  onSignupTypeToggle(type: string, checked: boolean) {
    if (checked) {
      this.signups.push(new FormControl(type));
    } else {
      const index = this.signups.controls.findIndex((control) => control.value === type);
      this.signups.removeAt(index)
    }
  }

  get signups(): FormArray {
    return this.form.get('signups') as FormArray;
  }

  get logins(): FormArray {
    return this.form.get('logins') as FormArray;
  }

  private setFormValue(): void {
    this.signups.clear();
    this.value.signups.forEach(s => this.signups.push(new FormControl(s)));
    this.logins.clear();
    this.value.logins.forEach(s => this.logins.push(new FormControl(s)));
    this.form.patchValue(this.value);
  }
}
